// generated by genversion
export const version = '6.12.1';
